import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';

export const FloatingCheckoutButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getCartCount, getCartTotal } = useCart();
  const count = getCartCount();
  const total = getCartTotal();

  // Don't show on admin pages or if cart is empty or if already on cart page
  const isHidden = 
    location.pathname.startsWith('/admin') || 
    location.pathname === '/cart' || 
    count === 0;

  if (isHidden) return null;

  const goToCart = () => {
    // Si venimos del catálogo con un filtro de categoría activo, lo limpiamos
    // antes de salir para que el botón "atrás" regrese a TODOS y no al filtro previo.
    if (location.pathname === '/catalogo' && location.search) {
      navigate('/catalogo', { replace: true });
    }
    navigate('/cart');
  };

  return (
    <div className="fixed bottom-6 right-6 z-[100] animate-in fade-in slide-in-from-bottom-10 duration-500">
      <button
        onClick={goToCart}
        className="group relative flex items-center gap-3 bg-[#39FF14] text-black px-6 py-4 rounded-2xl font-black shadow-[0_10px_30px_rgba(57,255,20,0.4)] hover:shadow-[0_15px_40px_rgba(57,255,20,0.6)] hover:scale-105 active:scale-95 transition-all"
      >
        <div className="relative">
          <ShoppingBag className="w-6 h-6" />
          <span className="absolute -top-2 -right-2 bg-black text-[#39FF14] text-[10px] w-5 h-5 flex items-center justify-center rounded-full border-2 border-[#39FF14] font-bold">
            {count}
          </span>
        </div>
        
        <div className="flex flex-col items-start leading-tight">
          <span className="text-[10px] uppercase tracking-widest opacity-70">Finalizar</span>
          <span className="text-sm">USD ${total.toFixed(2)}</span>
        </div>

        {/* Pulsing effect */}
        <div className="absolute inset-0 rounded-2xl bg-[#39FF14] animate-ping opacity-20 pointer-events-none"></div>
      </button>
    </div>
  );
};
